// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import reverseRightIcon from "@/assets/icons/reverse-right.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ReverseRightIconProps = Omit<IconProps, "name">;

export function ReverseRightIcon(props: ReverseRightIconProps): React.ReactNode {
  return <Icon name={reverseRightIcon} {...props} />;
}
